import React from 'react';
import { WORKSHOP_PHOTOS, ILLUSTRATIONS } from '../workshopPhotos';

/* Captioned photo grid with hover zoom — real shop photos */
export const WorkshopGallery = ({
  photos = WORKSHOP_PHOTOS,
  eyebrow = 'Real machines, real work',
  title = 'Inside our rebuild shop',
  subtitle = 'No stock photos here — this is our bench, our tools and the freeze dryers we bring back to life every week.',
  bg = 'bg-white',
  testid = 'workshop-gallery',
}) => (
  <section className={`py-20 section-padding ${bg}`} data-testid={testid}>
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-10">
        <span className="text-[#B87333] font-semibold text-xs uppercase tracking-[0.2em]">{eyebrow}</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#003456] mt-3">{title}</h2>
        {subtitle && <p className="text-slate-600 mt-3 leading-relaxed">{subtitle}</p>}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {photos.map((p, i) => (
          <figure
            key={i}
            className="group relative overflow-hidden rounded-2xl border border-slate-200 shadow-sm bg-slate-100 aspect-[4/3]"
            data-testid={`workshop-photo-${i}`}
          >
            <img
              src={p.src}
              alt={p.alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#003456]/90 via-[#003456]/15 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
              <span className="text-white text-sm font-medium leading-snug">{p.alt}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

/* Illustrated capability band using the brand linocuts */
export const IllustratedCapabilities = ({
  eyebrow = 'What we do best',
  title = 'From diagnosis to a machine that runs like new',
  bg = 'bg-[#F1F5F9]',
  testid = 'illustrated-capabilities',
}) => (
  <section className={`py-20 section-padding ${bg}`} data-testid={testid}>
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-12">
        <span className="text-[#B87333] font-semibold text-xs uppercase tracking-[0.2em]">{eyebrow}</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#003456] mt-3">{title}</h2>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {ILLUSTRATIONS.map((it) => (
          <div
            key={it.title}
            className="group bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-lg hover:border-[#CE8946]/50 transition-all"
            data-testid={`capability-${it.title.toLowerCase()}`}
          >
            <div className="aspect-square overflow-hidden bg-white">
              <img
                src={it.src}
                alt={it.title}
                loading="lazy"
                className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 border-t border-slate-100">
              <h3 className="text-base font-bold text-[#003456]">{it.title}</h3>
              <p className="text-slate-500 text-sm mt-1 leading-snug">{it.label}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
